import { cn } from '@/lib/utils';

import { Avatar } from '../../internals/Avatar';
import { suggestionId, type ChipChoice } from '../../internals/chipEntries';

export const Suggestions = ({
  id,
  choices,
  highlighted,
  onPick,
}: {
  id: string;
  choices: ChipChoice[];
  highlighted: number;
  onPick: (choice: ChipChoice) => void;
}) => (
  <ul
    id={id}
    role="listbox"
    className="flex max-w-80 flex-col gap-px rounded-lg border border-border bg-surface p-1 shadow-sm motion-opacity-in-0 motion-translate-y-in-[-2px] motion-duration-[120ms] motion-reduce:motion-duration-[60ms]"
  >
    {choices.map((choice, index) => (
      <li
        key={choice.value}
        id={suggestionId(id, index)}
        role="option"
        aria-selected={index === highlighted}
        // Keeps focus in the row's input while the press lands
        onMouseDown={(event) => event.preventDefault()}
        onClick={() => onPick(choice)}
        className={cn(
          'flex h-7 cursor-default items-center gap-2 rounded-md px-1.5 text-xs text-foreground',
          'hover:bg-surface-hover aria-selected:bg-surface-active'
        )}
      >
        {choice.color && !choice.avatar_url ? (
          <span
            aria-hidden="true"
            className="size-2 shrink-0 rounded-full"
            style={{ backgroundColor: choice.color }}
          />
        ) : (
          <Avatar
            id={choice.value}
            name={choice.label}
            avatarUrl={choice.avatar_url}
            shape="circle"
            size={16}
          />
        )}
        <span className="truncate font-medium">{choice.label}</span>
        {choice.detail || choice.value !== choice.label ? (
          <span className="truncate text-foreground-muted">
            {choice.detail ?? choice.value}
          </span>
        ) : null}
      </li>
    ))}
  </ul>
);
